import React from 'react';
import { Phone, Sparkles, ArrowUpRight, Shield } from 'lucide-react';
import { Button } from './ui/button';
import { COMPANY } from '../mock';

const FooterCTABand = () => {
  return (
    <section id="final-cta" data-testid="footer-cta-band" className="relative bg-[#0A1628] py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 brand-gradient-tech" />
      <div className="absolute inset-0 circuit-bg-dark opacity-40" />
      <div className="absolute -top-40 -left-40 w-[32rem] h-[32rem] rounded-full bg-[#2AA8E8]/15 blur-3xl" />
      <div className="absolute -bottom-40 -right-40 w-[32rem] h-[32rem] rounded-full bg-[#D4A24C]/15 blur-3xl" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#2AA8E8]/10 backdrop-blur-sm border border-[#2AA8E8]/30 text-xs font-bold text-[#2AA8E8] mb-6">
          <Shield className="w-3.5 h-3.5" />
          {COMPANY.mc} · {COMPANY.dot}
        </div>

        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] text-white tracking-tight">
          Ready to Experience
          <br />
          <span className="gold-text">Elite Service?</span>
        </h2>

        <p className="mt-6 text-base md:text-lg text-white/75 max-w-2xl mx-auto leading-relaxed">
          Join the brokers, dealers, auctions and customers who trust Excelence Inc for their critical transportation needs.
        </p>

        <div className="mt-10 flex flex-wrap gap-3 justify-center">
          <a href="/#quote">
            <Button data-testid="final-cta-quote-btn" className="btn-accent font-bold h-14 px-8 gap-2 text-base">
              <Sparkles className="w-4 h-4" /> Get My Quote
              <ArrowUpRight className="w-4 h-4" />
            </Button>
          </a>
          <a href={COMPANY.phoneHref}>
            <Button data-testid="final-cta-call-btn" variant="outline" className="h-14 px-8 border-white/30 text-white bg-white/5 hover:bg-white hover:text-[#0A1628] font-bold gap-2 backdrop-blur-sm text-base">
              <Phone className="w-4 h-4" /> Call Now · {COMPANY.phone}
            </Button>
          </a>
        </div>

        <div className="mt-10 flex items-center justify-center gap-4 text-[11px] font-bold uppercase tracking-widest text-white/50">
          <span>Free quote</span>
          <span className="w-1 h-1 rounded-full bg-[#D4A24C]" />
          <span>No upfront payment</span>
          <span className="w-1 h-1 rounded-full bg-[#D4A24C]" />
          <span>Dispatch in minutes</span>
        </div>
      </div>
    </section>
  );
};

export default FooterCTABand;
